module.exports = __webpack_public_path__ + "static/Rat@2x.9e21411b.png";